import type * as React from 'react';
import type { IRawItem, Item } from '../../types';

export const populateWithSlot = (
  items: Array<IRawItem> = [],
  slots: Record<string, React.ReactNode>,
): Array<Item> =>
  items.map(item => ({
    ...item,
    content: slots[item.id] || 'Error: empty slot',
  }));
